
export default {
	locale: "en-US", // probaly array of all possible locales, first one would be default

	// Logo file name in ../assets/img/
	// If null show placeholder
	logo: "apex_logo.png",

	// Some design changes per tenant
	theme: {
		logoBackgroundColor: null //any valid css value for colors
	},

	// Insurance types
	// Enums we can use here are defined in localization.insurance_types
	typesOfInsurance: ["travel", "medical"],

	passwordRules: {
		requireLength: 8,
		requireDigit: false,
		requireLowercase: false,
		requireNonAlphanumeric: false,
		requireUppercase: false,
		requireUniqueChars: 1
	},

	// we use dayjs syntax: https://github.com/iamkun/dayjs/blob/master/docs/en/API-reference.md#format-formatstringwithtokens-string
	dateFormat: "DD/MM/YYYY",
	dateTimeFormat: "DD/MM/YYYY HH:mm:ss",

	// ENUM of preferred currency
	// ENUMs of currencies are defined in localization
	preferredCurrency: "HKD",

	// Settings for files upload
	filesUpload: {
		types: [
			"jpg",
			"jpeg",
			"png",
			"gif",
			"tiff",
			"webp",
			"pdf",
			"doc",
			"xdoc",
			"csv",
			"xls",
			"xlsx",
			"zip",
			"rar"
		],
		maxFileSize: 15 * 1024 * 1024
	},

	// Flags for development in case we need some flags to show/hide some features for development
	devFlags: {},

	// What features can be seen by this client
	// Affects top menu and router global guard
	// id is used in router to prevent showing features that are not allowed
	// name and slug are used for menu in UI
	features: [
		"dashboard",
		"clients",
		"policies",
		"quotes",
		"reports",
		"internals",
		"users",
		"fileSystem",
    "setup"
	],

	// Feature Dashboard
	dashboard: {
		detail: {
			hasNumberOfClients: true,
			hasNumberOfPolicies: true,
			hasNumberOfQuotes: true,
			hasGraph: false
		}
	},

	// Feature clients
	clients: {
		creating: {
			// TODO: probably form config here
		},
		listing: {
			itemsPerPage: 30,
			// Here is a list of fields that will be mapped to GraphQL output
			columns: {
				individual: ["name", "email", "dateOfBirth", "createdAt", "actions"],
				company: [
					"name",
					"registrationNumber",
					"email",
					"natureOfBusiness",
					"createdAt",
					"actions"
				]
			}
		},
		detail: {
			submenu: {
				individual: ["overview", "policies", "logs"],
				company: ["overview", "policies", "logs"]
			}
		},
		updating: {}
	},

	paymentProvider: "stripe",
	// Feature Quotes
	quotes: {
		actions: {
			hasActions: true,
			hasRequestPayment: true,
			hasSendQuote: true,
			hasIssuePolicy: true
		},

		offers: {
			hasSendOffer: false
		},

		detail: {
			hasReject: false,
			hasChangeHolder: false,
			hasAddOtherHolder: false,
			hasRemoveOtherHolder: false,
			hasAddInsured: false,
			hasRemoveInsured: false
		}
	},

	// Feature policies
	policies: {
		creating: {
			hasApiCreation: false,
			hasManualCreation: false
		},
		actions: {
			hasActions: false,
			hasRequestPayment: false,
			hasSendConfirmation: false
		},
		cancelling: {
			hasCancel: false,
			hasSendEmail: false
		}
	},

	// Feature Reports
	reports: {
		reporting: {
			hasDefault: true,
			hasVHIS: false
		}
	}
}
